// 領収書フォーム。売上のチェックまたは入力額の税区分から金額欄を埋め、差引受領額をプレビューする。
// 金額欄は自由入力もできるので、確定値はサーバ側で再計算する。
document.addEventListener('turbo:load', () => {
  const totalEl = document.getElementById('receipt-total-amount');
  if (!totalEl) {
    return;
  }

  const CONSUMPTION_TAX_RATE = 0.1;

  const fields = {
    raw: document.getElementById('receipt_raw_amount'),
    tax: document.getElementById('receipt_consumption_tax_amount'),
    withholding: document.getElementById('receipt_withholding_amount'),
    expense: document.getElementById('receipt_expense_amount'),
  };

  const formatCurrency = (amount) =>
    new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' }).format(amount);

  const valueOf = (el) => (el ? parseFloat(el.value) || 0 : 0);

  const checkedValue = (name) => {
    const el = document.querySelector(`input[name="${name}"]:checked`);
    return el ? el.value : null;
  };

  // 差引受領額 = 報酬額 + 消費税 - 源泉徴収額 + 実費
  const updateTotal = () => {
    const total =
      valueOf(fields.raw) + valueOf(fields.tax) - valueOf(fields.withholding) + valueOf(fields.expense);
    totalEl.textContent = formatCurrency(total);
  };

  const fillFromEarnings = () => {
    let raw = 0;
    let tax = 0;
    let withholding = 0;

    document.querySelectorAll('.earning-checkbox:checked').forEach((checkbox) => {
      const row = checkbox.closest('tr');
      const amount = parseFloat(row.querySelector('[data-amount]').dataset.amount) || 0;
      const rowTax = parseFloat(row.querySelector('[data-consumption-tax]').dataset.consumptionTax) || 0;
      const rowWithholding = parseFloat(row.querySelector('[data-withholding]').dataset.withholding) || 0;

      raw += amount + rowWithholding - rowTax;
      tax += rowTax;
      withholding += rowWithholding;
    });

    if (fields.raw) fields.raw.value = raw;
    if (fields.tax) fields.tax.value = tax;
    if (fields.withholding) fields.withholding.value = withholding;
    updateTotal();
  };

  // 売上と同じ内外税計算。税込なら入力額から消費税を割り戻す。
  const splitTax = (amount, taxClass, consumptionTax) => {
    if (taxClass === 'non_taxable') {
      return { base: amount, tax: 0 };
    }
    if (consumptionTax === 'inclusive') {
      const tax = Math.round((amount / (1 + CONSUMPTION_TAX_RATE)) * CONSUMPTION_TAX_RATE);
      return { base: amount - tax, tax };
    }
    return { base: amount, tax: Math.round(amount * CONSUMPTION_TAX_RATE) };
  };

  // 売上と同じ源泉徴収税額。本体価格100万円までは10.21%、超過分は20.42%。
  const withholdingTaxOf = (base) =>
    base <= 1000000 ? Math.floor(base * 0.1021) : Math.floor((base - 1000000) * 0.2042 + 102100);

  const rewardInput = document.getElementById('receipt_reward_input_amount');
  const rewardTaxRow = document.getElementById('receipt-reward-tax-row');
  const expenseInput = document.getElementById('receipt_expense_input_amount');
  const expenseTaxRow = document.getElementById('receipt-expense-tax-row');
  const expenseBreakdown = document.getElementById('receipt-expense-tax-breakdown');
  const expenseTaxAmountEl = document.getElementById('receipt-expense-tax-amount');

  const calcReward = () => {
    const taxClass = checkedValue('reward_tax_class');
    const amount = Math.round(valueOf(rewardInput));
    const { base, tax } = splitTax(amount, taxClass, checkedValue('reward_consumption_tax'));
    const withhold = taxClass !== 'non_taxable' && checkedValue('reward_tax_withhold') === 'yes';

    if (fields.raw) fields.raw.value = base;
    if (fields.tax) fields.tax.value = tax;
    if (fields.withholding) fields.withholding.value = withhold ? withholdingTaxOf(base) : 0;
    updateTotal();
  };

  // 実費は源泉徴収の対象外。税抜で入力されたときは消費税を上乗せした税込額を実費欄に入れる。
  const calcExpense = () => {
    const amount = Math.round(valueOf(expenseInput));
    const { base, tax } = splitTax(amount, checkedValue('expense_tax_class'), checkedValue('expense_consumption_tax'));

    if (fields.expense) fields.expense.value = base + tax;
    if (expenseBreakdown) expenseBreakdown.style.display = tax > 0 ? '' : 'none';
    if (expenseTaxAmountEl) expenseTaxAmountEl.textContent = formatCurrency(tax);
    updateTotal();
  };

  // 非課税なら内外税と源泉徴収の選択は効かないので隠す
  const toggleTaxRows = () => {
    if (rewardTaxRow) {
      rewardTaxRow.style.display = checkedValue('reward_tax_class') === 'non_taxable' ? 'none' : '';
    }
    if (expenseTaxRow) {
      expenseTaxRow.style.display = checkedValue('expense_tax_class') === 'non_taxable' ? 'none' : '';
    }
  };

  const bindCalculator = (input, radioNames, calc) => {
    if (input) input.addEventListener('input', calc);
    radioNames.forEach((name) => {
      document.querySelectorAll(`input[name="${name}"]`).forEach((radio) => {
        radio.addEventListener('change', () => {
          toggleTaxRows();
          calc();
        });
      });
    });
  };

  bindCalculator(rewardInput, ['reward_tax_class', 'reward_consumption_tax', 'reward_tax_withhold'], calcReward);
  bindCalculator(expenseInput, ['expense_tax_class', 'expense_consumption_tax'], calcExpense);

  Object.values(fields).forEach((el) => {
    if (el) el.addEventListener('input', updateTotal);
  });

  document.querySelectorAll('.earning-checkbox').forEach((checkbox) => {
    checkbox.addEventListener('change', fillFromEarnings);
  });

  document.querySelectorAll('.select-all').forEach((selectAll) => {
    selectAll.addEventListener('change', (e) => {
      const table = e.target.closest('table');
      table.querySelectorAll('.item-checkbox').forEach((checkbox) => {
        checkbox.checked = e.target.checked;
      });
      fillFromEarnings();
    });
  });

  // 読み込み時は保存済み・売上由来の値を残したいので、計算はせず表示だけ整える
  toggleTaxRows();
  updateTotal();
});
